export enum AccountView {
  Home = "Home",
  Users = "Users",
  Surveys = "Surveys",
  Integrations = "Integrations",
}
